export default {
    user: {
        user_email: '',
        token: '',
        role: ''
    },
    allUsers: [],
    taxi_types: [],
    buses: [],
    travel_offers: [],
    taxi_requests: [],
    feedback: [],
    permissions: null
}
